// extracted by mini-css-extract-plugin
export default {"container":"_14sa8h9","oldContainer":"_n55hny","appInfo":"_113mv6j","appGallery":"_1xwt1tx"};